import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { AdditionalNavItem, Drawer, DrawerItem } from '@sitebase/web-shell-kit';
import { publish, subscribe, unsubscribe } from '@wh/message-bus';
import { LANGUAGE_ITEM_CLICKED, LANGUAGE_SELECT_COMMAND } from '../../../topics';
import { OPENBET_SUPPORTED_LOCALES } from '../../../../const';
import { redirectToOpenbet } from '../redirectToOpenbet';
import renderFlag from '../renderFlag';

const type = '@sportsbook/sub-nav-end-language-menu';

const makeOnClick = (data) => () => {
  const { code } = data;

  if (OPENBET_SUPPORTED_LOCALES.includes(code)) {
    redirectToOpenbet(code);
  } else {
    publish({ topic: LANGUAGE_ITEM_CLICKED, data });
  }
};

const LanguageMenuRenderer = ({ data: { languages, label } }) => {
  const [currentLangCode, setCurrentLangCode] = useState('');

  useEffect(() => {
    const subscribeId = subscribe({
      topic: LANGUAGE_SELECT_COMMAND,
      callback: ({ data }) => {
        if (currentLangCode !== data) {
          setCurrentLangCode(data);
        }
      },
    });
    return () => {
      unsubscribe(subscribeId);
    };
  }, []);

  const currentLang = languages.find(({ code }) => code === currentLangCode);

  return (
    <AdditionalNavItem icon={renderFlag(currentLang)} label={(currentLang && currentLang.label) || label}>
      <Drawer>
        {languages.map((item) => (
          <DrawerItem
            id={`${type}-${item.code}`}
            key={`${type}-${item.code}`}
            active={currentLangCode === item.code}
            onClick={makeOnClick(item)}
            icon={renderFlag(item)}
          >
            {item.label}
          </DrawerItem>
        ))}
      </Drawer>
    </AdditionalNavItem>
  );
};

LanguageMenuRenderer.propTypes = {
  data: PropTypes.shape({
    id: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    languages: PropTypes.arrayOf(
      PropTypes.shape({
        data: PropTypes.shape({
          code: PropTypes.string.isRequired,
          label: PropTypes.string.isRequired,
        }),
      })
    ),
  }),
};

export default {
  type,
  render: ({ data }) => <LanguageMenuRenderer key={data.id} data={data} />,
};
